<template>
  <div role="dialog" class="modal-manager" :style="[ isEmpty ? {'display': 'none'}: '']">
    <template v-for="m in mountedModals">
      <component 
        :ref="`modal_${m.id}`" 
        :is="m.modal" 
        :key="m.id"
      ></component>
    </template>
  </div>
</template>

<script>
import {
  default as createModalComponent
} from '@/components/createModal';

export default {
  name: 'modal-manager',
  data() {
    return {
      modals: []
    }
  },
  mounted() {
    window.ModalManager = {
      create: this.createModal,
      open: this.openModal,
      close: this.closeModal,
      mount: this.mountModal,
      unmount: this.unmountModal,
      remove: this.removeModal,
    };
  },
  beforeDestroy() {
    window.ModalManager = null;
  },
  computed: {
    mountedModals() {
      return this.modals.filter(m => m.mounted);
    },
    isEmpty() {
      if(!this.mountedModals) return true;

      if(this.mountedModals.length === 0 ) return true;

      return false
    }
  },
  methods: {
    _bindChainMethod: function(obj, name, fnc) {
      if (typeof fnc != 'function') return;

      obj[name] = () => {
        fnc();
        return obj || {};
      }
    },
    _isIDUsed: function(id) {
      return !!this.modals.find(m => m.id == id);
    },
    _getModalByID: function(id) {
      let modal = this.modals.find(m => m.id == id);
      if (!modal) {
        console.warn('[Modal Manager]: invalid id')
        return false;
      };

      return modal;
    },
    createModal: function( id, content ) {
      if (id == undefined || id == null) {
        console.warn('[Modal Manager]: Invalid id')
        return;
      }
      if (this._isIDUsed(id)) {
        console.warn('[Modal Manager]: Given id used')
        return;
      }
      const newModal = createModalComponent({id, content});
      this._bindChainMethod(newModal, 'open', () => this.openModal(id));
      this._bindChainMethod(newModal, 'close', () => this.closeModal(id));
      this._bindChainMethod(newModal, 'mount', () => this.mountModal(id));
      this._bindChainMethod(newModal, 'unmount', () => this.unmountModal(id));
      this._bindChainMethod(newModal, 'remove', () => this.removeModal(id));
      this.modals.push({
        id,
        mounted: false,
        modal: newModal
      });

      return newModal;
    },
    mountModal: function(id) {
      let modal = this._getModalByID(id);
      if (!modal) return;

      modal.mounted = true;
    },
    openModal: function(id) {
      console.log('_af_try_to_open_modal', id);
      let modal = this._getModalByID(id);
      if (!modal) return ;
      if (!modal.mounted) {
        console.warn("[ModalManager]: Can't open a unmount modal");
        return;
      }
      if (!this.$refs[`modal_${id}`]
        || !this.$refs[`modal_${id}`][0]
      ) {
        setTimeout(() => this.openModal(id), 100);
        return;
      }

      this.$refs[`modal_${id}`][0].open();
    },
    closeModal: function(id) {
      let modal = this._getModalByID(id);
      if (!modal) return ;
      if (!modal.mounted) {
        console.warn("[ModalManager]: Can't close a unmount modal");
        return;
      }
      if (!this.$refs[`modal_${id}`]
        || !this.$refs[`modal_${id}`][0]
      ) {
        setTimeout(() => this.closeModal(id), 100);
        return;
      }

      this.$refs[`modal_${id}`][0].close();
    },
    unmountModal: function(id) {
      let modal = this._getModalByID(id);
      if (!modal) return;
      
      // this.closeModal(id);
      modal.mounted = false;
    },
    removeModal: function(id) {
      let modal = this._getModalByID(id);
      if (!modal) return;

      this.unmountModal(id);
      let idx = this.modals.findIndex(m => m.id == modal.id);
      this.modals.splice(idx, 1);
      modal = modal.modal;
      typeof modal._onDestroyFnc == 'function' && modal._onDestroyFnc();
    }
  }
}
</script>
